/*
 * Данные приложения, не являющиеся ответом API: конфигурация навигации и список
 * менеджеров для экрана входа.
 *
 * Менеджеры перенесены из макета (../../../design-source/data.jsx: MANAGERS).
 * Настоящей авторизации на этой итерации нет; как она будет устроена - ADR-006
 * (architecture/adr/ADR-006-authentication-and-authorization.md).
 */

export interface Manager {
  id: string;
  name: string;
  initials: string;
  color: string;
  email: string;
}

export const MANAGERS: ReadonlyArray<Manager> = [
  {
    id: 'm1',
    name: 'Снежана',
    initials: 'Сн',
    color: '#16a34a',
    email: 'snejana@kultura.ru',
  },
  {
    id: 'm2',
    name: 'Света',
    initials: 'Св',
    color: '#2563eb',
    email: 'sveta@kultura.ru',
  },
  {
    id: 'm3',
    name: 'Артур',
    initials: 'Ар',
    color: '#ea580c',
    email: 'artur@kultura.ru',
  },
  {
    id: 'm4',
    name: 'Лариса',
    initials: 'Ла',
    color: '#9333ea',
    email: 'larisa@kultura.ru',
  },
];

/** Иконка пункта меню - имя экспорта из lucide-react. */
export type NavIconName =
  | 'LayoutDashboard'
  | 'Truck'
  | 'Package'
  | 'Calendar'
  | 'ClipboardList'
  | 'FlaskConical'
  | 'History'
  | 'RefreshCw'
  | 'Settings'
  | 'Users'
  | 'Warehouse'
  | 'Workflow';

/** Счётчик у пункта меню: «в работе» - как фильтр «Активные», «план» - запланированные. */
export type NavCount = 'inWork' | 'plan';

export interface NavItem {
  label: string;
  to: string;
  icon: NavIconName;
  count?: NavCount;
  /** Пункт из макета, до которого ещё не дошли: показываем, но не ведём никуда. */
  isPlanned?: boolean;
}

export interface NavGroup {
  label: string;
  items: ReadonlyArray<NavItem>;
}

/*
 * Состав меню повторяет сайдбар макета. Реализованные экраны ведут на свой
 * маршрут; остальные помечены isPlanned - так видно и целевую картину, и
 * текущую готовность.
 */
export const NAV_GROUPS: ReadonlyArray<NavGroup> = [
  {
    label: 'Рабочее место',
    items: [
      { label: 'Мои задачи', to: '/dashboard', icon: 'LayoutDashboard' },
      { label: 'План отгрузок', to: '/plan', icon: 'Calendar', count: 'plan' },
      {
        label: 'Отгрузки в работе',
        to: '/shipments',
        icon: 'Truck',
        count: 'inWork',
      },
      { label: 'История отгрузок', to: '/history', icon: 'History' },
      {
        label: 'Ротация культур',
        to: '/rotation',
        icon: 'RefreshCw',
        isPlanned: true,
      },
      { label: 'Статусы и процессы', to: '/flow', icon: 'Workflow' },
    ],
  },
  {
    label: 'Справочники',
    items: [
      { label: 'Товар', to: '/goods', icon: 'Package' },
      { label: 'Клиенты', to: '/customers', icon: 'Users' },
      { label: 'Склады', to: '/warehouses', icon: 'Warehouse' },
      { label: 'Заказы 1С', to: '/orders', icon: 'ClipboardList' },
      {
        label: 'План тестирования образцов',
        to: '/sample-tests',
        icon: 'FlaskConical',
      },
    ],
  },
  {
    label: 'Система',
    items: [{ label: 'Настройки', to: '/settings', icon: 'Settings' }],
  },
];
